module.exports = __webpack_public_path__ + "static/media/01B.0f5188e6.png";